const zustandXOpts = {
    devtools: {
        enabled: process.env.NODE_ENV !== 'production'
    },
    persist: {
        enabled: true,
        name: 'soundbetween',
        partialize: (state) => ({
            token: state.token
        }),
    }
}

export default zustandXOpts;